import React from 'react'

import {FieldViewGroupProps} from "../../../../../render/group/@type"
import HintPopover from "../../../../../../gd-ui/hint-popover/hint-popover"
import FieldTimeReportActivityType from "../../activity-type-field"
import {MyTimeListGroup} from "../../../../../../../app/home/my-time/daily/@type";

// const debug = "FieldTimeReportActivityType_ViewGroup"
const debug = false

function FieldTimeReportActivityType_ViewGroup(props: FieldViewGroupProps) {
    const field = props.field as FieldTimeReportActivityType
    const id    = props.model[field.fieldId] as string
    const group: MyTimeListGroup = field.groupById[id]

    const classes = Classes("flex-row-left-center ui5-txt-less-important ui5-txt-bold h-45", props.className)

    debug && console.log(debug, 'render', group, field.groupById, props.model)

    return (
        <div className={classes}>
            <div className="txt-truncate view-group-label">
                {group.title}
            </div>

            {props.counter}

            {group.hint &&
                <div className="help ui5-ico-help v2 flex-row-center-center p-0 w-20i h-20 m-l-10 ui5-txt-normal">
                    <HintPopover
                        hint        = {group.hint}
                        multiline   = {true}
                    />
                </div>
            }
        </div>
    )
}

FieldTimeReportActivityType_ViewGroup.supportsCounter = true

export default FieldTimeReportActivityType_ViewGroup
